import { MobileAppRequest } from './mobile-app-request.model';
// tslint:disable: variable-name
export class TransferFundsRequest {
  RequestHeader: MobileAppRequest;
  OperatorLogin: string;
  StationNumber: number;
  POSID: number;
  SourceMemberID: string;
  SourceACN: number;
  TargetMemberID: string;
  TargetAccountID: string;
  TransRef: string;
  AmountInPence: number;
  TargetEmailAddress: string;

  constructor(
    sourceMemberId: string,
    sourceAcn: number,
    targetMemberId: string,
    targetAccountId: string,
    amountInPence: number,
    targetEmailAddress: string
  ) {
    this.RequestHeader = new MobileAppRequest();
    this.SourceMemberID = sourceMemberId;
    this.SourceACN = sourceAcn;
    this.TargetMemberID = targetMemberId;
    this.TargetAccountID = targetAccountId;
    this.AmountInPence = amountInPence;
    this.TargetEmailAddress = targetEmailAddress;
    this.TransRef = 'Transfer Funds';
  }
}
